/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AdminOpenRouterKey,
  AdminOpenRouterKey$inboundSchema,
} from "./adminopenrouterkey.js";

export type ListKeysResponseBody2 = {
  /**
   * Every live platform OpenRouter key, ordered by organization slug then key type.
   */
  keys: Array<AdminOpenRouterKey>;
};

/** @internal */
export const ListKeysResponseBody2$inboundSchema: z.ZodMiniType<
  ListKeysResponseBody2,
  unknown
> = z.object({
  keys: z.array(AdminOpenRouterKey$inboundSchema),
});

export function listKeysResponseBody2FromJSON(
  jsonString: string,
): SafeParseResult<ListKeysResponseBody2, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListKeysResponseBody2$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListKeysResponseBody2' from JSON`,
  );
}
